import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getOrganisationRoleAccess } from "../utils/roleAccess";

export default function OrganisationSidebar({ setShow, show }) {
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const access = getOrganisationRoleAccess(userData);
  // console.log({ userData }, userData?.organisationGroupId?._id);
  const gotoDashBoard = () => {
    navigate(`/organisations/dashboard`);
  };

  return (
    <aside>
      <div className="sidebar">
        <div className="toggle-icon" onClick={() => setShow(!show)}>
          <img
            src={require("../../Assets/Images/toggle.svg").default}
            alt="Toggle sidebar"
          />
        </div>
        <div
          className="logo-side"
          onClick={gotoDashBoard}
          style={{ cursor: "pointer" }}
        >
          <img
            className="small"
            src={require("../../Assets/Images/clogo.png")}
            alt="Peerscroller icon"
          />
          <img
            className="big"
            src={require("../../Assets/Images/main-logo.png")}
            alt="Peerscroller"
          />
        </div>
        <div className="side-menu">
          <div>
            {!show && (
              <p className="organisation-sidebar-section">
                {userData?.organisationGroupId?.name || "Your Organisation Group"}
              </p>
            )}
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname === "/organisations/dashboard"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/organisations/dashboard"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="-1.2 -1.2 24 24"
                  id="Finance-Fill--Streamline-Outlined-Fill-Material"
                  height="24"
                  width="24"
                >
                  <path
                    fill="#0e0e0e"
                    d="M4.05 18.900000000000002c-0.36000000000000004 0 -0.675 -0.135 -0.9450000000000001 -0.405 -0.27 -0.27 -0.405 -0.5850000000000001 -0.405 -0.9450000000000001V2.7h1.35v14.85h14.85v1.35H4.05Zm1.6875 -3.0375v-7.515h2.6775v7.515h-2.6775Zm4.455 0v-12.15h2.6775v12.15h-2.6775Zm4.365 0v-3.825h2.6775v3.825h-2.6775Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Dashboard</p>
              </Link>
            </div>
            {access.canViewMemberOrganisations && (
              <>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname ===
                      "/organisations/member-organisations"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to="/organisations/member-organisations"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      id="Hub-Network-Fill"
                      height="24"
                      width="24"
                    >
                      <path
                        fill="#000000"
                        d="M 12.000,8.400 A 3.600,3.600 0 1 1 12.000,15.600 A 3.600,3.600 0 1 1 12.000,8.400 Z M 12.000,10.000 A 2.000,2.000 0 1 0 12.000,14.000 A 2.000,2.000 0 1 0 12.000,10.000 Z M 12.000,1.800 A 2.400,2.400 0 1 1 12.000,6.600 A 2.400,2.400 0 1 1 12.000,1.800 Z M 12.000,3.200 A 1.000,1.000 0 1 0 12.000,5.200 A 1.000,1.000 0 1 0 12.000,3.200 Z M 12.600,8.800 L 12.600,6.200 L 11.400,6.200 L 11.400,8.800 Z M 19.418,7.190 A 2.400,2.400 0 1 1 19.418,11.990 A 2.400,2.400 0 1 1 19.418,7.190 Z M 19.418,8.590 A 1.000,1.000 0 1 0 19.418,10.590 A 1.000,1.000 0 1 0 19.418,8.590 Z M 15.229,11.582 L 17.702,10.778 L 17.331,9.637 L 14.858,10.441 Z M 16.585,15.910 A 2.400,2.400 0 1 1 16.585,20.710 A 2.400,2.400 0 1 1 16.585,15.910 Z M 16.585,17.310 A 1.000,1.000 0 1 0 16.585,19.310 A 1.000,1.000 0 1 0 16.585,17.310 Z M 13.396,14.942 L 14.924,17.045 L 15.895,16.340 L 14.366,14.236 Z M 7.415,15.910 A 2.400,2.400 0 1 1 7.415,20.710 A 2.400,2.400 0 1 1 7.415,15.910 Z M 7.415,17.310 A 1.000,1.000 0 1 0 7.415,19.310 A 1.000,1.000 0 1 0 7.415,17.310 Z M 9.634,14.236 L 8.105,16.340 L 9.076,17.045 L 10.604,14.942 Z M 4.582,7.190 A 2.400,2.400 0 1 1 4.582,11.990 A 2.400,2.400 0 1 1 4.582,7.190 Z M 4.582,8.590 A 1.000,1.000 0 1 0 4.582,10.590 A 1.000,1.000 0 1 0 4.582,8.590 Z M 9.142,10.441 L 6.669,9.637 L 6.298,10.778 L 8.771,11.582 Z"
                        strokeWidth="0.5"
                      />
                    </svg>
                    <p>Member Organisations</p>
                  </Link>
                </div>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname === "/organisations/members"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to="/organisations/members"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      id="Map-Fill--Streamline-Outlined-Fill-Material"
                      height="24"
                      width="24"
                    >
                      <path
                        fill="#000000"
                        d="M15.5 21.5 9 19.5l-6.5 2V5l6.5 -2 6.5 2 6.5 -2v16.5l-6.5 2ZM15.5 19.5v-13l-6.5 -2v13l6.5 2Z"
                        strokeWidth="0.5"
                      />
                    </svg>
                    <p>Group Staff</p>
                  </Link>
                </div>
              </>
            )}
            {access.canViewStaff && (
              <div className="side-btm-space">
                <Link
                  className={
                    window.location.pathname === "/organisations/staff"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/organisations/staff"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    id="School-Fill--Streamline-Outlined-Fill-Material"
                    height="24"
                    width="24"
                  >
                    <path
                      fill="#000000"
                      d="M21.5 16.925v-7.05L11.975 15 1 9 11.975 3 23 9v7.925h-1.5ZM11.975 21l-7.25 -3.975v-5.25l7.25 3.975 7.25 -3.975v5.25L11.975 21Z"
                      strokeWidth="0.5"
                    />
                  </svg>
                  <p>Staff</p>
                </Link>
              </div>
            )}
          </div>

          <div>
            {!show && (
              <p className="organisation-sidebar-section">Your Account</p>
            )}
            <Link
              to="/organisations/help-support"
              className={
                window.location.pathname === "/organisations/help-support" ||
                window.location.pathname === "/organisations/report-issue"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <g clipPath="url(#organisation-help-circle)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.9375 9C0.9375 4.5472 4.5472 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9ZM9 6.375C8.58577 6.375 8.25 6.71079 8.25 7.125C8.25 7.53923 7.91423 7.875 7.5 7.875C7.08578 7.875 6.75 7.53923 6.75 7.125C6.75 5.88236 7.75733 4.875 9 4.875C10.2427 4.875 11.25 5.88236 11.25 7.125C11.25 7.57177 11.119 7.99027 10.8931 8.34142C10.7575 8.5521 10.6003 8.7513 10.4603 8.9253L10.3837 9.02025C10.2678 9.16365 10.1649 9.29107 10.0695 9.42217C9.83243 9.74797 9.75 9.95775 9.75 10.125C9.75 10.5392 9.41422 10.875 9 10.875C8.58577 10.875 8.25 10.5392 8.25 10.125C8.25 9.4638 8.5746 8.92725 8.8566 8.53965C8.97652 8.37488 9.10808 8.21205 9.22447 8.0682L9.29167 7.98495C9.43042 7.81252 9.54308 7.6674 9.63165 7.52977C9.7065 7.4134 9.75 7.27543 9.75 7.125C9.75 6.71079 9.41422 6.375 9 6.375ZM8.99662 11.625C8.58427 11.625 8.25 11.9608 8.25 12.375C8.25 12.7892 8.58427 13.125 8.99662 13.125H9.00338C9.41573 13.125 9.75 12.7892 9.75 12.375C9.75 11.9608 9.41573 11.625 9.00338 11.625H8.99662Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </g>
                <defs>
                  <clipPath id="organisation-help-circle">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p>Help &amp; Support</p>
            </Link>
            <Link
              to="/organisations/settings"
              className={
                window.location.pathname === "/organisations/settings"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.64997 18C6.50962 17.9679 6.36326 17.9519 6.22893 17.9018C5.22246 17.5349 4.31023 17.0036 3.4862 16.32C3.06317 15.9691 2.96292 15.4559 3.18547 14.9046C3.57843 13.9263 3.43007 13.0281 2.73235 12.2382C2.34741 11.8032 1.8522 11.5546 1.27478 11.4744C0.553008 11.3742 0.218186 11.0574 0.103906 10.3277C-0.0604973 9.28919 -0.0264137 8.2507 0.182098 7.22024C0.292368 6.67293 0.677313 6.33813 1.25072 6.26195C2.88673 6.04544 3.84308 4.4817 3.28772 2.92999C3.07319 2.33056 3.21554 1.84941 3.71877 1.46248C4.4646 0.88711 5.2786 0.432022 6.15876 0.099227C6.7061 -0.107266 7.18528 0.0110162 7.56621 0.45207C8.64486 1.70306 10.3671 1.70506 11.4417 0.458084C11.8307 0.00500187 12.3018 -0.109271 12.8632 0.103237C13.8276 0.468108 14.7057 0.97933 15.5017 1.63289C15.9588 2.00779 16.0951 2.47089 15.9047 3.02622C15.3834 4.54986 16.2535 6.04944 17.8314 6.34214C18.4188 6.4504 18.7476 6.7852 18.8559 7.36659C19.0584 8.44316 19.0424 9.51573 18.8399 10.5903C18.7416 11.1075 18.3507 11.4744 17.8194 11.5566C16.1894 11.8032 15.2671 13.379 15.8465 14.9267C16.055 15.482 15.9247 15.9651 15.4676 16.342C14.7278 16.9475 13.9158 17.4326 13.0316 17.7955C12.5003 18.014 11.981 17.8757 11.6161 17.4246C10.5235 16.0694 8.67092 16.0934 7.61433 17.4788C7.37174 17.7975 7.06097 17.9739 6.64997 18ZM12.6707 8.97443C12.6707 7.24831 11.2472 5.8229 9.52101 5.8209C7.7627 5.8209 6.33519 7.23428 6.3372 8.97844C6.3392 10.7346 7.75067 12.148 9.50497 12.152C11.2533 12.154 12.6707 10.7306 12.6707 8.97443Z"
                  fill="black"
                  fillOpacity="0.8"
                />
              </svg>
              <p>Settings</p>
            </Link>
          </div>
        </div>
      </div>
    </aside>
  );
}
